import React, { useState, Fragment } from "react";
import moment from "moment";
import _ from "lodash";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

import PencilOutline from "mdi-material-ui/PencilOutline";
import DeleteOutline from "mdi-material-ui/DeleteOutline";

import QuickSearchToolbar from "views/components/QuickSearchToolbar";
import DialogModal from "@core/components/dialogmodal";
import ImageModal from "@core/components/imagemodal";
import { isPermissionAllow } from "@core/utils/IsPermissionAllow";

const renderClient = (params) => {
  const { row } = params;
  if (row.image) {
    return <img alt="img" src={`${row.image}`} width="40px" height="40px" />;
  }
};

const TodaysProgramList = (props) => {
  const {
    handleDeleteModal,
    deleteOpen,
    handleOpen,
    programtList,
    pageSize,
    searchText,
    pageNumber,
    setPageSize,
    setSearchText,
    setPageNumber,
    totalRecord,
    permission,
    role,
  } = props;
  const [deleteId, setDeleteId] = useState(null);
  const [openImage, setOpenImage] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);

  const handleEdit = (id) => {
    handleOpen("edit", id);
  };

  const handleDelete = (id) => {
    handleDeleteModal();
    setDeleteId(id);
  };

  const handleImageModal = (url) => {
    setImageUrl(url);
    setOpenImage(true);
  };

  const handleClose = () => {
    setOpenImage(false);
  };

  const columns = [
    {
      flex: 0.5,
      minWidth: 80,
      field: "index",
      headerName: "Index",
    },
    {
      flex: 1,
      minWidth: 150,
      field: "title",
      headerName: "Title",
    },
    {
      flex: 1,
      minWidth: 150,
      field: "description",
      headerName: "Description",
    },
    {
      flex: 1,
      minWidth: 150,
      field: "date",
      headerName: "Start Date",
      renderCell: ({ row }) => {
        const fmt = "MMM DD, YYYY HH:mm A";
        const m = moment.utc(row.date).format(fmt);
        return (
          <Typography sx={{ fontSize: "0.92rem !important" }}>{m}</Typography>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "end_date",
      headerName: "End Date",
      renderCell: ({ row }) => {
        const fmt = "MMM DD, YYYY HH:mm A";
        const formatDate = moment.utc(row.end_date).format(fmt);
        return (
          <Typography sx={{ fontSize: "0.92rem !important" }}>
            {formatDate}
          </Typography>
        );
      },
    },
    {
      flex: 0.7,
      minWidth: 80,
      field: "image",
      headerName: "Image",
      renderCell: (params) => {
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              alignSelf: "center",
              cursor: "pointer",
            }}
            onClick={() => handleImageModal(params.row.image)}
          >
            {renderClient(params)}
          </Box>
        );
      },
    },
    {
      flex: 1,
      minWidth: 140,
      field: "created_at",
      headerName: "created date",
      renderCell: ({ row }) => {
        const formatDate = moment
          .utc(row.created_at)
          .format("DD-MM-yyyy HH:mm:ss");
        return (
          <Typography sx={{ fontSize: "0.92rem !important" }}>
            {formatDate}
          </Typography>
        );
      },
    },

    {
      flex: 0.7,
      minWidth: 100,
      field: "action",
      headerName: "Actions",
      renderCell: ({ row }) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              {((permission.edit && role === "2") || role === "1") && (
                <IconButton onClick={() => handleEdit(row.id)}>
                  <PencilOutline fontSize="medium" />
                </IconButton>
              )}
              {((permission.delete && role === "2") || role === "1") && (
                <IconButton onClick={() => handleDelete(row.id)}>
                  <DeleteOutline fontSize="medium" />
                </IconButton>
              )}
            </Box>
          </Box>
        );
      },
    },
  ];
  const removeaction =
    !permission.edit && !permission.delete && role === "2"
      ? _.dropRight(columns)
      : columns;
  const handleSearch = (searchValue) => {
    setSearchText(searchValue);
  };

  const assemList = programtList.map((data, index) => {
    return {
      index: index + pageSize * pageNumber + 1,
      id: data.id,
      title: data.title,
      description: data.description,
      image: data.image,
      date: data.date,
      end_date: data.end_date,
      content: data.content,
      created_at: data.created_at,
    };
  });

  return (
    <Fragment>
      <Card sx={{ width: "100%", overflowInline: "hidden" }}>
        <DataGrid
          hideFooterSelectedRowCount
          autoHeight
          localeText={{ noRowsLabel: "No results found" }}
          rowCount={Number(totalRecord)}
          page={pageNumber}
          columns={removeaction}
          rows={assemList}
          pageSize={pageSize}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={(newPageNumber) => setPageNumber(newPageNumber)}
          components={{ Toolbar: QuickSearchToolbar }}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          onSelectionModelChange={(rows) => setSelectedRows(rows)}
          pagination
          paginationMode="server"
          checkboxSelection={isPermissionAllow(permission.delete, role)}
          disableSelectionOnClick
          componentsProps={{
            toolbar: {
              value: searchText,
              clearSearch: () => handleSearch(""),
              onChange: (event) => handleSearch(event.target.value),
              handleOpen: () => handleOpen("add"),
              title:
                (permission.edit && role === "2") || role === "1"
                  ? "Add Program"
                  : "",
              selectedRows: selectedRows,
              onClickDelete: () => handleDeleteModal(),
              multiDelete: isPermissionAllow(permission.delete, role),
            },
          }}
          sx={{
            ".MuiTablePagination-displayedRows": {
              marginTop: "1rem",
            },
            ".MuiTablePagination-selectLabel": {
              marginTop: "1.1rem",
            },
            ".MuiInputBase-root": {
              marginTop: "0.2rem",
            },
          }}
        />
      </Card>

      {deleteOpen && (
        <DialogModal
          open={deleteOpen}
          handleClose={() => handleDeleteModal()}
          handleDelete={() =>
            handleDeleteModal(
              selectedRows && selectedRows.length === 0
                ? [deleteId]
                : selectedRows
            )
          }
        />
      )}

      {openImage && (
        <ImageModal
          open={openImage}
          handleClose={handleClose}
          imageUrl={imageUrl}
        />
      )}
    </Fragment>
  );
};

export default TodaysProgramList;
